import { c as _c } from "react/compiler-runtime";
import { FormInput, PaymentProcessorEnum, PrimaryButton, getPaymentProcessorTitle } from '@systemeio/ui';
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { getConnectionWebhookBaseUrl } from 'modules/profile/payment-gateways/integrations/secure-and-pay/constants';
import { useSecureAndPayRestApi } from 'modules/profile/payment-gateways/integrations/secure-and-pay/hooks';
import { PaymentSecureAndPayErrorInterface, PaymentSecureAndPayInterface } from 'modules/profile/payment-gateways/integrations/secure-and-pay/types';
import { getSecureAndPayHelpPageLink } from 'modules/profile/payment-gateways/integrations/secure-and-pay/utils';
import React, { useState } from 'react';
import { CopyToClipboardButton } from 'shared/components/copy-to-clipboard-button';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
const defaultValues: PaymentSecureAndPayInterface = {
  siteId: 0,
  key: ''
};
const defaultErrors: PaymentSecureAndPayErrorInterface = {
  siteId: '',
  key: ''
};
const SecureAndPayCreateModal = () => {
  const $ = _c(50);
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      badRequestHandler: error => setErrors({
        ...defaultErrors,
        ...error.errors.fields
      })
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    connect
  } = useSecureAndPayRestApi(t0);
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getConnectionWebhookBaseUrl();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const connectionWebhookUrl = `${t1}/${user?.slug}`;
  let t2;
  if ($[2] !== connect || $[3] !== mutatePaymentIntegrations) {
    t2 = async data => {
      await connect(data);
      await mutatePaymentIntegrations();
    };
    $[2] = connect;
    $[3] = mutatePaymentIntegrations;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onCreate = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e => {
      e.preventDefault();
      setOpened(true);
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("dashboard.settings.payment_gateways.connect");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <PrimaryButton onClick={t3} className="font-bold">{t4}</PrimaryButton>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("dashboard.settings.payment_gateways.connect_payment_title", {
      payment: getPaymentProcessorTitle(PaymentProcessorEnum.SecureAndPay)
    });
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = getPaymentProcessorTitle(PaymentProcessorEnum.SecureAndPay);
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setOpened(false);
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== errors || $[15] !== t) {
    t9 = {
      field: "siteId",
      onRender: (value, onChange) => <FormInput key="secure-and-pay-site-id-create" label={t("dashboard.settings.payment-gateways.site_id")} value={value} type="number" onChange={e_0 => onChange(e_0.target.valueAsNumber)} error={errors.siteId} />
    };
    $[14] = errors;
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== errors || $[18] !== t) {
    t10 = {
      field: "key",
      onRender: (value_0, onChange_0) => <FormInput key="secure-and-pay-key-create" label={t("dashboard.settings.payment-gateways.api_secret_key")} value={value_0} onChange={e_1 => onChange_0(e_1.target.value)} error={errors.key} />
    };
    $[17] = errors;
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = [t9, t10];
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t("dashboard.settings.payment-gateways.webhook_url");
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = `${t12}:`;
  let t14;
  if ($[25] !== t13) {
    t14 = <span>{t13}</span>;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  let t16;
  if ($[27] !== connectionWebhookUrl) {
    t15 = <span className="text-text-primary truncate" title={connectionWebhookUrl}>{connectionWebhookUrl}</span>;
    t16 = <CopyToClipboardButton text={connectionWebhookUrl} />;
    $[27] = connectionWebhookUrl;
    $[28] = t15;
    $[29] = t16;
  } else {
    t15 = $[28];
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t14 || $[31] !== t15 || $[32] !== t16) {
    t17 = <div className="flex items-baseline gap-1 truncate text-base lg:text-lg">{t14}{t15}{t16}</div>;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  const t18 = user?.dashboardLocale;
  let t19;
  if ($[34] !== t18) {
    t19 = getSecureAndPayHelpPageLink(t18);
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = getPaymentProcessorTitle(PaymentProcessorEnum.SecureAndPay);
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t19) {
    t21 = <HelpCenterLink link={t19} integration={t20} />;
    $[37] = t19;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = ["siteId", "key"];
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== onCreate || $[41] !== opened || $[42] !== t11 || $[43] !== t17 || $[44] !== t21 || $[45] !== t6) {
    t23 = <CreateModal fullCaption={t6} caption={t7} opened={opened} onClose={t8} defaultValues={defaultValues} needToast={false} creatable={t11} modalDescription={t17} additionalInfo={t21} onCreate={onCreate} requiredFields={t22} />;
    $[40] = onCreate;
    $[41] = opened;
    $[42] = t11;
    $[43] = t17;
    $[44] = t21;
    $[45] = t6;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t23 || $[48] !== t5) {
    t24 = <>{t5}{t23}</>;
    $[47] = t23;
    $[48] = t5;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  return t24;
};
export default SecureAndPayCreateModal;